import styled from 'styled-components';

const CourseEnrollCategory = styled.div`
  color: #71bad8;
  font-size: 14px;
  margin-bottom: 4px;
  font-weight: 400;
`;

export default CourseEnrollCategory;
